import React, { useState, useEffect, useMemo } from "react";
import "@assets/css/Products.css";
import "@assets/css/Contact.css";
import Accordion from "@components/Accordion";
import Product from "@components/Product";
import product_img_menu from "@data/product_img_menu";
import categories from "@data/categories";
import { useNavigate, useLocation } from "react-router-dom";
import Vertical_banner from "../../components/vertical_banner/vertical_banner";
import debounce from "lodash.debounce";
import Reveal from "@components/Reveal/Reveal";

const Products = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [category, setCategory] = useState("UTRUSTNING");
  const [listItems, setListItems] = useState([]);
  const [targetItem, setTargetItem] = useState(null);
  const [path, setPath] = useState(["UTRUSTNING"]);
  const [keyword, setKeyword] = useState("");
  const [productId, setProductId] = useState("");
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const [leavingId, setLeavingId] = useState(null);

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);
    return () => window.removeEventListener("resize", updateDimension);
  }, []);

  // Debounced search function
  const debouncedSearch = useMemo(
    () =>
      debounce((kw) => {
        const lowerKeyword = kw?.trim().toLowerCase();

        const filteredItems = product_img_menu.filter((item) => {
          const productName = item.product_name?.toString().toLowerCase() || "";
          const producer = item.producer?.toString().toLowerCase() || "";
          const category = item.category?.toString().toLowerCase() || "";

          return (
            productName.startsWith(lowerKeyword) ||
            producer.startsWith(lowerKeyword) ||
            category.startsWith(lowerKeyword)
          );
        });

        setListItems(filteredItems);
        setPath([`SEARCH for ${kw}`]);

        if (kw) {
          navigate(`/utrustning/SEARCH for ${encodeURIComponent(kw)}`);
        } else {
          navigate("/utrustning");
        }
      }, 300),
    []
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // Sync with URL path
  useEffect(() => {
  setLeavingId(null);
  const pathFromURL = decodeURI(location.pathname.replace("/utrustning", ""))
  .split("/")
      .filter(Boolean);

    const currentCategory =
      pathFromURL.length > 0 ? pathFromURL[pathFromURL.length - 1] : "UTRUSTNING";

    setCategory(currentCategory);
    setPath(["UTRUSTNING", ...pathFromURL]);

    const target = product_img_menu.find(
      (item) => item.product_name?.toLowerCase() === currentCategory.toLowerCase()
    );

    if (target) {
      setTargetItem(target);
      setProductId(target.id);
    } else {
      setTargetItem(null);
      setProductId("");
    }

    if (!keyword.trim()) {
      setListItems(
        product_img_menu.filter(
          (item) => item.category?.toLowerCase() === currentCategory?.toLowerCase()
        )
      );
    }
  }, [location]);

  const handleSearchInputChange = (e) => {
    const keyword = e.target.value;
    setKeyword(keyword);

    if (!keyword.trim()) {
      setCategory("UTRUSTNING");
      setPath(["UTRUSTNING"]);
      setListItems(
        product_img_menu.filter(
          (item) => item.category?.toLowerCase() === "utrustning"
        )
      );
      navigate("/utrustning");
    } else {
      debouncedSearch(keyword);
    }
  };

  const handleCardClick = (item) => {
  if (leavingId) return; // förhindrar dubbelklick medan korten tonas ut
  setLeavingId(item.id);
  setTimeout(() => handleChangeCategory(item, "product"), 600);
};

  const handleChangeCategory = (item, type = "product") => {
    setKeyword("");
    let pathList = [];

    if (!item) {
      pathList = [];
    } else if (type === "category") {
      const parents = item.parents || [];
      pathList = [...parents, item.category];
    } else {
      pathList = [item.product_name];
      let productCategory = item.category;
      while (productCategory && productCategory !== "UTRUSTNING") {
        const parent = product_img_menu.find(
          (product) => product.product_name === productCategory
        );
        if (!parent) break;
        pathList.unshift(parent.product_name);
        productCategory = parent.category;
      }
    }

    const cleanPath = pathList.filter((p) => p !== "UTRUSTNING");

    navigate(`/utrustning/${cleanPath.join("/")}`);
  };

  const handlePathChange = (category) => {
    const index = path.indexOf(category);
    const sliced = path.slice(1, index + 1);
    navigate(`/utrustning/${sliced.join("/")}`);
  };

  const generatePath = (path) => {
    const shortPath =
      screenSize.width > 1200 ? path : path.length > 2 ? path.slice(-2) : path;

    return shortPath.map((p, index) => {
      if (index === 0) {
        return (
          <span onClick={() => handlePathChange(p)} className="top-path" key={index}>
            {p}
          </span>
        );
      } else {
        return (
          <React.Fragment key={p}>
            <span className="mx-1">&gt;</span>
            <span onClick={() => handlePathChange(p)} className="top-path">
              {p}
            </span>
          </React.Fragment>
        );
      }
    });
  };

  return (
    <div className="Products">
      <Vertical_banner />
      <div id="productContainer">
        {screenSize.width > 1200 && (
          <Accordion
            category={category}
            setCategory={handleChangeCategory}
            handleSearch={handleSearchInputChange}
            keyword={keyword}
          />
        )}
        <div id="product-card">
          <div className="productheader">
            <div className="productheader_menu">{generatePath(path)}</div>
            {!targetItem || targetItem.level < 4 ? (
              <div className="main_content">
                {listItems.map((item, index) => (
  <Reveal key={item.id} delay={(index % 3) * 100}>
  <div className={`box${leavingId ? (leavingId === item.id ? " box-selected" : " box-fading") : ""}`}>
    <div
      className="bubba-container"
      onClick={() => handleCardClick(item)}
      >
        <figure className="effect-bubba">
          <img src={process.env.PUBLIC_URL + `/${item.thumb}`} alt="" />
          <figcaption>
            <div className="heading-text">
              <h1>{item.product_name}</h1>
              <h4>{item.producer}</h4>
            </div>
          </figcaption>
        </figure>
      </div>
    </div>
  </Reveal>
))}
              </div>
            ) : (
              <Product productId={productId} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
